import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'BIO_UPDATE',
    smsDelete : 'BIO_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {

        submitSuccess: false,
        bioDetail:{},
        bioLoading: false,
        bioError: false,

        ...store
    },

    mutations : {
        ...mutations,

     
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SET_BIO_DETAIL (state, detail) {
            state.bioDetail= detail;
        },

        BIO_LOADING (state, loading) {
            state.bioLoading = loading;
        },

        BIO_ERROR (state, hasError) {
            state.bioError = hasError;
        },
    },

    actions: {
       

    
        async addBio ({commit, dispatch}, payload) {
        commit('BIO_LOADING', true);
        commit('BIO_ERROR', false);

        let config = {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
        };

        try{
            let response = await axios.post(V1API.create_bio, payload.bio, config).then(result=>{
                let data = result.data
                return data

            });

            commit('SUBMIT_SUCCESS', true);
            dispatch ('fetchBioDetails')
            
            return response

        }catch (e) {
            commit('BIO_ERROR', true);
        }finally {
            commit('BIO_LOADING', false);
        }
    },
    
    
    async fetchBioDetails ({ commit },payload) {
        commit('BIO_LOADING', true);
        commit('BIO_ERROR', false);

        let config = {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            }
        };

        try{
            let result = await axios.get(V1API.get_bio_details, config);
            let response = result.data.data

            commit('SET_BIO_DETAIL', response);

        } catch(error) {
            commit('BIO_ERROR', true);
        }
        finally {
            commit('BIO_LOADING', false);
        }
    },
    },

    getters: {}
}
